<script>
    export let bg = "bg-white";
</script>

<div class="flex border-b justify-between {bg} sticky" style="top:0; z-index: 11;">
    <slot/>
</div>